module.exports = __webpack_public_path__ + "static/media/emplacement-2.190c4df2.svg";